import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import Confirm from 'Components/Partials/Modals/Confirm';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';

import FrequencyOptions from 'Config/ScheduledReportFrequencyOptions';

import AdminScheduledReportsApi from 'Services/Api/Admin/ScheduledReports';

export default class Index extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Title',
            value: 'title',
            type: 'string',
            orderable: 'title'
        },
        {
            label: 'Frequency',
            value: (record) => FrequencyOptions.find(option => option.value === record.frequency).label,
            type: 'callback',
            orderable: 'frequency'
        },
        {
            label: 'Emails',
            value: (record) => record.emails?.join(', '),
            type: 'callback',
            orderable: null
        },
        {
            label: 'Enabled',
            value: 'enabled',
            type: 'boolean',
            orderable: 'enabled'
        },
    ];
    
    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        return [
            {
                type: "link",
                to: "/admin/scheduled-reports/store/"+item.id,
                text: "Update"
            },
            {
                type: "link",
                to: "/admin/scheduled-reports/reports/"+item.id,
                text: "Reports"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    itemName: 'scheduled report',
                    itemId: item.id,
                    onDeleteApi: AdminScheduledReportsApi.delete
                },
                text: 'Delete'
            },
            {
                type: "modalTrigger",
                component: Confirm,
                props: {
                    onConfirm: () => AdminScheduledReportsApi.sendToMe(item.id),
                },
                text: 'Send To Me Now'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <AdminLayout title="Scheduled Reports">
                <IndexTable
                    columns={this.columns}
                    displaySearchBar={false}
                    storeLink="/admin/scheduled-reports/store"
                    loadDataCallback={(data) => AdminScheduledReportsApi.get(null, data)}
                    rowActions={this.getRowActions}
                    actionsJustify="center"
                    rowClickRedirect={(item) => "/admin/scheduled-reports/reports/"+item.id}
                    eventApi={AdminScheduledReportsApi}
                    instructions="Click on a scheduled report below to build the reports"
                />
            </AdminLayout>
        )
    }
}
